import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        airports: [],
    }
}

const getters = {
    airports: state => state.airports,
};

const actions = {
    fetchAirports({commit, state}) {
        Http.get(API_URL + VERSION + '/airports')
            .then(response => {
                commit('setAirports', response.data)
            })

    }
};

const mutations = {
    setAirports(state, items) {
        state.airports = items
    },
};

export default {
    state: initialState,
    getters,
    actions,
    mutations
}
